import {
  fetchPageTitleData,
  fetchValproCardData,
  fetchSummaryData,
  fetchHouseMeasuresData,
  fetchWeissInsightsData,
  fetchZipCodeHouses,
  fetchSegmentationData,
  fetchCompsData,
  fetchIndexToolsData,
  fetchValproData,
} from "./index";

export const prefetchReportQueries = async (
  queryClient,
  filters,
  reportType = "address"
) => {
  const queries = [
    {
      queryKey: ["pageTitleData", filters],
      queryFn: () => fetchPageTitleData(filters),
      staleTime: 1000 * 60 * 60 * 24,
    },
  ];

  await Promise.all(
    queries.map((query) =>
      queryClient.prefetchQuery(query.queryKey, query.queryFn, {
        staleTime: query.staleTime,
      })
    )
  );
};

export const prefetchPropertyData = async (queryClient, filters) => {
  const queries = [
    {
      queryKey: ["fetchValproCardData", filters],
      queryFn: () => fetchValproCardData(filters),
      staleTime: 1000 * 60 * 60 * 24,
    },
    {
      queryKey: ["fetchSummaryData", filters],
      queryFn: () => fetchSummaryData(filters),
      staleTime: 1000 * 60 * 60 * 24,
    },
    {
      queryKey: ["fetchHouseMeasuresData", filters],
      queryFn: () => fetchHouseMeasuresData(filters),
      staleTime: 1000 * 60 * 60 * 24,
    },
    {
      queryKey: ["fetchWeissInsightsData", filters],
      queryFn: () => fetchWeissInsightsData(filters),
      staleTime: 1000 * 60 * 60 * 24,
    },
    {
      queryKey: ["fetchZipCodeHouses", filters],
      queryFn: () => fetchZipCodeHouses(filters),
      staleTime: 1000 * 60 * 60 * 24,
    },
    {
      queryKey: ["fetchSegmentationData", filters],
      queryFn: () => fetchSegmentationData(filters),
      staleTime: 1000 * 60 * 60 * 24,
    },
    {
      queryKey: ["fetchCompsData", filters],
      queryFn: () => fetchCompsData(filters),
      staleTime: 1000 * 60 * 60 * 24,
    },
    {
      queryKey: ["fetchIndexToolsData", filters],
      queryFn: () => fetchIndexToolsData(filters),
      staleTime: 1000 * 60 * 60 * 24,
    },
    {
      queryKey: ["fetchValproData", filters],
      queryFn: () => fetchValproData(filters),
      staleTime: 1000 * 60 * 60 * 24,
    },
  ];

  queries.forEach((query) =>
    queryClient.prefetchQuery(query.queryKey, query.queryFn, {
      staleTime: query.staleTime,
    })
  );
};
